import BlockList from '../../../data/constant/BlocksList';
import { useCameraStateContext } from '../../../contexts/CameraContext';
import useBlockAdd from '../../../hook/block/useBlock';
import { useTreeStateContext } from '../../../contexts/TreeContext';
import { cloneDeep } from 'lodash';
import { useEffect } from 'react';

// Component use to create a block when you click on him
function BlockCreationLink({ className, label, image, onClose, position, shortcut }) {

    const { addBlock } = useBlockAdd();
    const { blocks } = useTreeStateContext();

    const { panzone } = useCameraStateContext();

    // Default offset for the block creation, place him on the top left corner of the bot edtiro
    const offset = { x: position == null ? 30 : position?.x, y: position == null ? 120 : position?.y };

    const onClick = () => {

        var { x, y, scale } = panzone.getTransform();
        const block = cloneDeep(BlockList[className]);
        // Change the default name for the scenario's block, exemple if 3 scenario have already been created the fourth will be call 'Scenario 4'
        if (block.tree.type.name == 'scenario') {
            let numberOfScenarios = blocks.filter(block => block.type.name == 'scenario').length;
            block.tree.name = 'Scenario ' + numberOfScenarios;
        }

        if (block.server.basic !== undefined) {
            block.server.basic = 0
        }

        if (block.tree.data !== undefined && block.tree.data.basic !== undefined) {
            block.tree.data.basic = 0
        }

        addBlock({ ...block }, x / scale, y / scale, offset.x, offset.y);
        onClose();
    }

    const handleKeyDown = (e) => {
        if (shortcut == null) {
            return;
        }
        if (e.keyCode == shortcut.value) {
            onClick()
            e.preventDefault();
        }
    }

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    return (
        <div className={"block_template " + className} onClick={onClick}>
            <img className="background-image" src={image} />
            <label className='shortcut-block-template'> {shortcut ? "[" + shortcut.title + "] " : " "}</label>

            <label>{label}</label>
        </div>
    )
}

export default BlockCreationLink;